import * as SharedAcross from './utilities/SharedAcross';
import React, {useState}  from 'react';
import NormalIcon from './StockItems/NormalIcon';

function App(props) {

  var clickImage = props.clickImage;
  var width = props.width;
  var nos = props.nos;
  var currentImageUrl = props.currentImageUrl;
  var filteredImages = props.filteredImages;
  var clickDelete = props.clickDelete;

  const [overImageID, setOverImageID] = useState(-1);

  function doClickImage(url, w, h){
    return function(e){
        clickImage(url, w, h);
    }
  }


  function hoverImage(imageID){
    return function(e){
      setOverImageID(imageID);
    }
  }

  var grid = SharedAcross.convertToGrid(filteredImages, nos, true);
  var rows = grid.map((aRow, index)=>{
    var cells = aRow.map((aCell, index2)=>{
      if (aCell){
        var className = 'sCellLight';
        var url = aCell.v[1].v;
        if (url === currentImageUrl){
          className = "sCell";
        }
        var item = <img alt="" src={url} style={{width:width*0.8*0.95/nos}} />

        var deleteCell = null;
        if (aCell.v[0].v === overImageID && clickDelete){
          deleteCell = <NormalIcon icon='fe:trash' title='Delete' height='30px' onClick = {clickDelete(aCell.v[0].v)} style={{position:'absolute', top:0, right:0}}/>
        }

        // draggable={!clickImage}    + ' noFiringInside'
        return <td style={{width:"20%", textAlign:"center", cursor:'pointer', position:'relative'}} key={index2} onClick={doClickImage(url, aCell.v[3].v, aCell.v[4].v)} className={className} onMouseOver={hoverImage(aCell.v[0].v)} >{item}{deleteCell}</td>
//
      }else{
        return <td style={{width:"20%"}} key={index2}></td>
//
      }
    })
    return <tr key={index}>{cells}</tr>
  })
  return <table width={width*0.8}><tbody>{rows}</tbody></table>

//

}


export default App;
